export const ROLES = {
     ADVISER : 'adviser',
     SUPER_ADMIN : 'super-admin',
     CUSTOMER : 'customer',
     BROKER: 'broker'
}